export default __webpack_public_path__ + "static/media/12 3D (2-5).db98974c.jpg";